import { aloApiFetch } from 'src/scripts/utils/alo-api-fetch';
import { GeocodeParams, LatLng, LatLngError } from './storeLocatorTypes';
import { getCurrentGeoLocationPosition } from 'src/scripts/utils/location';
import {
  setCustomerLatLongLocation,
  setCustomerLocationErrorState,
  resetCustomerLatLongLocation,
  resetCustomerZipcode,
} from './customerLocationState';
import { ShippingCountryState } from 'src/scripts/utils/shipping';
import { mapCountryCode } from '../FindInStore/findInStoresUtils';

export const getGeocode = async (params: GeocodeParams): Promise<LatLng | LatLngError> => {
  const urlParams = new URLSearchParams();
  urlParams.set('postal_code', params.postal_code);
  urlParams.set('country_code', params.country_code);

  const response = await aloApiFetch(`/v1/geocode?${urlParams.toString()}`);

  if (!response.ok) {
    const status = response.status;
    console.error('Error fetching geocode:', status);
    const error = await response.json();
    error.status = status;
    return { error };
  }

  const data: LatLng = await response.json();
  return data;
};

export const getCurrentLocation = async () => {
  setCustomerLocationErrorState(false);
  try {
    const data = await getCurrentGeoLocationPosition();
    const { latitude, longitude } = data;
    resetCustomerZipcode();
    setCustomerLatLongLocation(latitude.toString(), longitude.toString());
    return { success: true };
  } catch (err) {
    resetCustomerLatLongLocation();
    return { success: false };
  }
};

interface CountryConfig {
  [key: string]: { regex: string; maxLength: number; localizedPostalOrZipTitle: string };
}

const countryConfig: CountryConfig = {
  US: { regex: '^\\d{5}$', maxLength: 5, localizedPostalOrZipTitle: 'zip' },
  CA: { regex: '^[A-Za-z]\\d[A-Za-z][ ]?\\d[A-Za-z]\\d$', maxLength: 7, localizedPostalOrZipTitle: 'postal' },
  UK: {
    regex: '[a-zA-Z]{1,2}[0-9][0-9a-zA-Z]?\\s?[0-9][a-zA-Z]{2}|[Gg][Ii][Rr]\\s?0[Aa][Aa]$',
    maxLength: 8,
    localizedPostalOrZipTitle: 'postal',
  },
  default: {
    regex: '^[A-Za-z0-9 ]{1,12}$',
    maxLength: 12,
    localizedPostalOrZipTitle: 'postal',
  },
};

export const getCountryPostalConfig = () => {
  return countryConfig[mapCountryCode(ShippingCountryState.countryCode)] || countryConfig['default']!;
};

export const getNoResultsCopy = ({ isFis = false }: { isFis?: boolean }) => {
  const { localizedPostalOrZipTitle } = getCountryPostalConfig();
  return isFis
    ? `Sorry, there are no ALO stores found near you. Try a different ${localizedPostalOrZipTitle} code.`
    : `No stores found near you. Try a different ${localizedPostalOrZipTitle} code or have it shipped.`;
};
